// extracted by mini-css-extract-plugin
export default {"wrapper":"AddAuditSummary_wrapper__HzESX","questionContainer":"AddAuditSummary_questionContainer__qmQJz","customInput":"AddAuditSummary_customInput__5H4Th"};